export default "__VITE_ASSET__D$JD$m3m__"